var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};


site.frontpage = {
	init: function() {
		site.frontpage.scroll();
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	}
};

const toogleArray = function(array, value) {
	const index = array.indexOf(value);

	if (index === -1) {
		array.push(value);
	} else {
		array.splice(index, 1);
	}
};

site.recipes = {
	grid: null,
	activeFilter: '*',
	activeAuthor: '*',
	init:function() {
		site.recipes.grid = $('.category.recipes .items').isotope({
			itemSelector: '.recipe__single',
			layoutMode: 'fitRows'
		});

		var $filterControls = $('.recipe__filter__controls');
		$filterControls.find('button').on('click', function() {
			const hashItems = window.location.hash.substr(1).split(',').filter(item => item !== '');
			const filter = $(this).data('filter');
			toogleArray(hashItems, filter);
			console.log(hashItems);

			site.recipes.activeFilter = filter === '*' ? filter : hashItems.join(',');
			site.recipes.updateIsotope();
		});

		$filterControls.find('select').on('change', function() {
			site.recipes.activeAuthor = $(this).val();
			site.recipes.updateIsotope();
		});

		window.onhashchange = function() {
			var $hash = window.location.hash.substr(1);
			// console.log($hash);
			if (!$hash.match(/[a-z]/i)) {
				window.location.hash = '';
				$('button[data-filter]').removeClass('active');
				$("button[data-filter='*']").addClass('active');
			} else {
				var $formattedHash = $hash.split(',').filter(Boolean);
				$('button[data-filter]').removeClass('active');
				for (var i = 0; i < $formattedHash.length; i++) {
					var $cleanHash = $formattedHash[i];
					var $targetBtn = $("button[data-filter='" + $cleanHash + "']");
					if ($targetBtn.length) {
						$targetBtn.addClass('active');
						site.recipes.activeFilter = '.' + $cleanHash;
					}
					var $author = $('#author');
					var $targetOption = $author.find("option[value='" + $cleanHash + "']");
					if ($targetOption.length) {
						$author.val($targetOption.val());
						site.recipes.activeAuthor = '.' + $cleanHash;
					}
				}
				if (!$("button[data-filter].active").length) {
					$("button[data-filter='*']").addClass('active');
				}
			}
			// console.log($hash);
			site.recipes.grid.isotope({filter: $hash});
		};

		$(window).trigger('hashchange')
	},
	updateIsotope: function() {
		var $activeFilter = site.recipes.activeFilter;
		var $activeAuthor = site.recipes.activeAuthor;
		var $filterStr = $activeFilter + $activeAuthor;
		$filterStr = $filterStr.replace('*', '');

		window.location.hash = $filterStr;
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.recipeView')) {
		var $recipeCarouselConfig = {
			items: 3,
			dots: true,
			responsive: {
				0: {
					items: 1
				},
				500: {
					items: 2
				},
				768: {
					items: 3
				},
				992: {
					items: 4
				},
			}
		};
		site.owl.init('.recipes__carousel', $recipeCarouselConfig);
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	site.activeImage.init('.recipe__images');
	site.recipes.init();

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
